import $ from 'jquery';
import * as Const from './const.js';

export default {
  go_to(target) {
    // Does a scroll target exist?
    if (target.length) {
      let height = target.offset().top - Const.$header.height();
      if (height < 0) {
        height = 0;
      }
      $('html, body').animate({
        scrollTop: height,
      }, 500);
    }
  },
  load() {
    let _self = this;
    $('a[href*="#"]:not(.no-scroll):not(.js-no-scroll):not([href="#"]):not([data-toggle])').click(function(event) {
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
        &&
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        let target = $(this.hash);

        if (this.hash && this.hash.startsWith('#go-')) {
          target = $('#' + this.hash.substring(4));
        }

        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

        _self.go_to(target);

        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
      }
    });
  },

  onload_go_to() {
    if (location.hash && location.hash.startsWith('#go-')) {
      let target = '#' + location.hash.substring(4);
      if ($(target).length) {
        $('html, body').animate({
          scrollTop: $(target).offset().top - Const.$header.height(),
        }, 500);

        location.hash = target;
      }
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/util/anchor.js